import * as Icons from "lucide-react";
import type { LucideProps } from "lucide-react";
import { memo } from "react";

// Resolving a lucide icon by a fuzzy name requires scanning every exported icon
// (~1500 entries). Cache the result per name so repeated renders (e.g. arrow-key
// navigation through the mention menu) don't re-run that scan for every item.
const iconCache = new Map<string, React.ComponentType<LucideProps>>();

const resolveIcon = (name: string): React.ComponentType<LucideProps> => {
    const cached = iconCache.get(name);
    if (cached) return cached;

    const exact = (Icons as any)[name];
    const component =
        exact ||
        (() => {
            const normalized = name.toLowerCase().replace(/[-_ ]/g, "");
            const match = Object.keys(Icons).find(
                (k) => k.toLowerCase() === normalized,
            );
            return (Icons as any)[match || "Wrench"];
        })();

    iconCache.set(name, component);
    return component;
};

const ToolIcon = ({ name, ...props }: { name: string } & LucideProps) => {
    if (name.startsWith("http")) {
        return <img src={name} alt="icon" {...(props as React.ImgHTMLAttributes<HTMLImageElement>)} />;
    }
    const IconComponent = resolveIcon(name);
    return <IconComponent {...props} />;
};

export default memo(ToolIcon);
